(function () {
  'use strict';

  function setStatus(root, message, tone) {
    const el = root.querySelector('[data-bis-status]');
    if (!el) return;
    el.hidden = !message;
    el.textContent = message || '';
    el.dataset.tone = tone || 'info';
  }

  async function submitForm(root, form) {
    const submit = form.querySelector('[data-bis-submit]');
    const emailInput = form.querySelector('[data-bis-email]');
    const variantInput = form.querySelector('[data-bis-variant]');
    const consentInput = form.querySelector('[data-bis-consent]');
    const endpoint = root.getAttribute('data-endpoint');
    const hasCustomerEmail = root.getAttribute('data-has-customer-email') === 'true';

    const email = (emailInput && emailInput.value ? emailInput.value : '').trim();
    if (!hasCustomerEmail && !email) {
      setStatus(root, 'Enter your email to get notified.', 'error');
      emailInput?.focus();
      return;
    }
    if (!consentInput?.checked) {
      setStatus(root, 'Confirm that you want a one-time restock email.', 'error');
      consentInput?.focus();
      return;
    }

    if (submit) {
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
    }
    setStatus(root, 'Saving…', 'info');

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          variantId: variantInput ? variantInput.value : root.getAttribute('data-variant-id'),
          email: email || undefined,
          consent: consentInput.checked,
        }),
        credentials: 'same-origin',
      });

      let payload = {};
      try {
        payload = await response.json();
      } catch (_) {
        payload = {};
      }

      if (payload.success) {
        setStatus(root, payload.message || "You're on the list.", 'success');
        if (submit) {
          submit.textContent = "You're on the list";
          submit.disabled = true;
        }
        return;
      }

      setStatus(
        root,
        payload.message || 'Could not save your request. Please try again.',
        'error'
      );
      if (submit) submit.disabled = false;
    } catch (_) {
      setStatus(root, 'Network error. Please try again.', 'error');
      if (submit) submit.disabled = false;
    } finally {
      if (submit) submit.removeAttribute('aria-busy');
    }
  }

  function bindRoot(root) {
    if (!root || root.dataset.bisBound === '1') return;
    root.dataset.bisBound = '1';
    const form = root.querySelector('[data-bis-form]');
    if (!form) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitForm(root, form);
    });
  }

  function bindAll(scope) {
    (scope || document).querySelectorAll('[data-bis-root]').forEach(bindRoot);
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindAll(document);
  });

  if (window.subscribe && window.PUB_SUB_EVENTS?.variantChange) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
      // product-info.js replaces the notify block HTML; re-bind after swap.
      requestAnimationFrame(function () {
        bindAll(document);
      });
    });
  }

  // Expose for product-info post-process hooks
  window.BlueberryBackInStock = { bindAll: bindAll };
})();
